
















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { CourseProduct } from '@/model/product/courseProduct'
import { order } from '@/apps/website/utils/order'
import ShoppingCart from '@/model/product/shoppingCart'

@Component
export default class LecturerMsgPC extends Vue {
  @Prop() private courseProduct!: CourseProduct

  canBuy() {
    return (this.courseProduct.id as string).indexOf('test') !== -1
  }

  get isMobile() {
    return document.body.clientWidth <= 800
  }
  getAuthorNames() {
    let names = []
    if (this.courseProduct.authors) {
      names = this.courseProduct.authors.map((item: any) => item.authorName)
    }
    return names.join(',')
  }
  async addToShoppingCart() {
    console.log('课程详情页添加购物车--PC')
    let shoppingCart: ShoppingCart = {
      products: [this.courseProduct]
    }
    order([this.courseProduct], false)
    this.$ykdmessage({
      message: '加入购物清单成功！',
      duration: 1500,
      cancel: () => {},
      type: 'error',
      iconUrl: '//style.youkeda.com/img/sandwich/home_m/success.png'
    })
  }
}
